/* Harrow Collection theme JS
   Vanilla, no dependencies. Cart drawer via AJAX Cart API + Section Rendering API. */
(function () {
  'use strict';

  /* ---------- utils ---------- */
  function $(sel, ctx) { return (ctx || document).querySelector(sel); }
  function $$(sel, ctx) { return Array.prototype.slice.call((ctx || document).querySelectorAll(sel)); }

  function formatMoney(cents, format) {
    var value = (cents / 100).toFixed(2);
    var parts = value.split('.');
    var whole = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    var f = format || window.theme.moneyFormat || '{{ amount }}';
    var amount;
    if (f.indexOf('amount_no_decimals') !== -1) {
      amount = Math.round(cents / 100).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
      return f.replace(/\{\{\s*amount_no_decimals\s*\}\}/, amount);
    }
    if (f.indexOf('amount_with_comma_separator') !== -1) {
      amount = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, '.') + ',' + parts[1];
      return f.replace(/\{\{\s*amount_with_comma_separator\s*\}\}/, amount);
    }
    return f.replace(/\{\{\s*amount\s*\}\}/, whole + '.' + parts[1]);
  }

  /* ---------- scroll reveal ---------- */
  function initReveal(root) {
    var els = $$('.reveal', root);
    if (!('IntersectionObserver' in window)) {
      els.forEach(function (el) { el.dataset.shown = 'true'; });
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.dataset.shown = 'true';
          io.unobserve(entry.target);
        }
      });
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0.08 });
    els.forEach(function (el) {
      if (el.dataset.shown !== 'true') io.observe(el);
    });
  }

  /* ---------- mobile menu ---------- */
  function initMobileMenu() {
    var menu = $('#MobileMenu');
    if (!menu) return;
    function setOpen(open) {
      menu.dataset.open = open ? 'true' : 'false';
      document.body.classList.toggle('overflow-locked', open);
      var burger = $('[data-menu-open]');
      if (burger) burger.setAttribute('aria-expanded', open ? 'true' : 'false');
    }
    $$('[data-menu-open]').forEach(function (b) { b.addEventListener('click', function () { setOpen(true); }); });
    $$('[data-menu-close]', menu).forEach(function (b) { b.addEventListener('click', function () { setOpen(false); }); });
    menu.addEventListener('click', function (e) { if (e.target.classList.contains('mobile-menu__overlay')) setOpen(false); });
    $$('a', menu).forEach(function (a) { a.addEventListener('click', function () { setOpen(false); }); });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && menu.dataset.open === 'true') setOpen(false); });
  }

  /* ---------- cart drawer ---------- */
  var cart = {
    open: function () {
      var d = $('#CartDrawer');
      if (!d) return;
      d.dataset.open = 'true';
      document.body.classList.add('overflow-locked');
    },
    close: function () {
      var d = $('#CartDrawer');
      if (!d) return;
      d.dataset.open = 'false';
      document.body.classList.remove('overflow-locked');
    },
    refresh: function () {
      return fetch(window.location.pathname + '?section_id=cart-drawer')
        .then(function (r) { return r.text(); })
        .then(function (html) {
          var doc = new DOMParser().parseFromString(html, 'text/html');
          var fresh = doc.querySelector('#CartDrawerContent');
          var current = $('#CartDrawerContent');
          if (fresh && current) current.innerHTML = fresh.innerHTML;
          var freshCount = doc.querySelector('[data-cart-count-source]');
          if (freshCount) {
            var n = parseInt(freshCount.getAttribute('data-cart-count-source'), 10) || 0;
            cart.updateCount(n);
          }
          bindCartDrawer();
        });
    },
    updateCount: function (n) {
      $$('[data-cart-count]').forEach(function (el) {
        el.textContent = n;
        el.classList.toggle('hidden', n === 0);
      });
    },
    addItems: function (items) {
      return fetch(window.routes.cart_add_url + '.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ items: items })
      }).then(function (r) {
        if (!r.ok) return r.json().then(function (e) { throw e; });
        return r.json();
      });
    },
    add: function (id, quantity, properties) {
      var body = { items: [{ id: id, quantity: quantity || 1 }] };
      if (properties && Object.keys(properties).length) body.items[0].properties = properties;
      return fetch(window.routes.cart_add_url + '.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(body)
      }).then(function (r) {
        if (!r.ok) return r.json().then(function (e) { throw e; });
        return r.json();
      });
    },
    change: function (key, quantity) {
      return fetch(window.routes.cart_change_url + '.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: key, quantity: quantity })
      }).then(function (r) { return r.json(); });
    }
  };
  window.HarrowCart = cart;

  function bindCartDrawer() {
    var d = $('#CartDrawer');
    if (!d) return;
    $$('[data-cart-close]', d).forEach(function (b) {
      b.onclick = cart.close;
    });
    var ov = $('.cart-drawer__overlay', d);
    if (ov) ov.onclick = cart.close;
    $$('[data-line-remove]', d).forEach(function (b) {
      b.onclick = function () {
        cart.change(b.getAttribute('data-line-remove'), 0).then(cart.refresh);
      };
    });
    $$('[data-line-plus]', d).forEach(function (b) {
      b.onclick = function () {
        cart.change(b.getAttribute('data-line-plus'), parseInt(b.getAttribute('data-qty'), 10) + 1).then(cart.refresh);
      };
    });
    $$('[data-quick-add]', d).forEach(function (b) {
      b.onclick = function (e) {
        e.preventDefault();
        cart.add(parseInt(b.getAttribute('data-quick-add'), 10), 1)
          .then(function () { return cart.refresh(); })
          .catch(function () { toast('Could not add to basket'); });
      };
    });
    $$('[data-line-minus]', d).forEach(function (b) {
      b.onclick = function () {
        cart.change(b.getAttribute('data-line-minus'), Math.max(0, parseInt(b.getAttribute('data-qty'), 10) - 1)).then(cart.refresh);
      };
    });
  }

  function initCartTriggers() {
    $$('[data-cart-open]').forEach(function (b) {
      b.addEventListener('click', function (e) {
        e.preventDefault();
        cart.open();
      });
    });
    document.addEventListener('keydown', function (e) {
      var d = $('#CartDrawer');
      if (e.key === 'Escape' && d && d.dataset.open === 'true') cart.close();
    });
  }

  /* ---------- product form (PDP) ---------- */
  function initProductForm() {
    var root = $('[data-product-root]');
    if (!root) return;
    var productData = JSON.parse($('#ProductJson', root).textContent);
    var variants = productData.variants;
    var options = productData.options;

    function currentSelection() {
      var sel = {};
      options.forEach(function (opt, i) {
        var checked = $('[data-option-index="' + i + '"] [aria-pressed="true"]', root);
        if (checked) sel[i] = checked.getAttribute('data-value');
      });
      return sel;
    }

    function findVariant(sel) {
      return variants.find(function (v) {
        return options.every(function (opt, i) {
          return v.options[i] === sel[i];
        });
      });
    }

    function updateUI() {
      var sel = currentSelection();
      var variant = findVariant(sel);
      var atc = $('[data-atc]', root);
      var buyNow = $('[data-buy-now]', root);
      var priceEls = $$('[data-price]', root);
      var stickyPrice = $('[data-sticky-price]', root);
      var idInput = $('[data-variant-id]', root);

      options.forEach(function (opt, i) {
        var label = $('[data-option-index="' + i + '"] [data-selected-value]', root);
        if (label) label.textContent = sel[i] || '';
        $$('[data-option-index="' + i + '"] [data-value]', root).forEach(function (btn) {
          var candidate = Object.assign({}, sel);
          candidate[i] = btn.getAttribute('data-value');
          var available = variants.some(function (v) {
            return options.every(function (o, j) { return v.options[j] === candidate[j]; }) && v.available;
          });
          btn.classList.toggle('unavailable', !available);
        });
      });

      if (!variant) return;
      if (idInput) idInput.value = variant.id;
      priceEls.forEach(function (el) { el.textContent = formatMoney(variant.price); });
      if (stickyPrice) stickyPrice.textContent = formatMoney(variant.price);
      var soldOut = !variant.available;
      [atc, buyNow].forEach(function (b) { if (b) b.disabled = soldOut; });
      if (atc) {
        $('[data-atc-label]', atc).textContent = soldOut
          ? atc.getAttribute('data-soldout-text')
          : atc.getAttribute('data-add-text') + ' — ' + formatMoney(variant.price);
      }
      /* Which option is the colour? By name first, then by recognising the
         selected value as a colour word in any of the shop languages. */
      var colourIdx = -1;
      options.forEach(function (o, oi) { if (/colou?r|kolor|farbe|colore/i.test(o)) colourIdx = oi; });
      if (colourIdx === -1) {
        options.forEach(function (o, oi) {
          if (colourKeys(sel[oi]).length) colourIdx = oi;
        });
      }
      var vimg = variant.featured_image;
      var vpos = vimg ? parseInt(vimg.position, 10) : 0;
      if (colourIdx >= 0 && window.galleryApplyColour) {
        window.galleryApplyColour(sel[colourIdx], vpos);
      } else if (vpos) {
        gallerySet(vpos - 1);
      }
      var url = new URL(window.location.href);
      url.searchParams.set('variant', variant.id);
      window.history.replaceState({}, '', url.toString());
    }

    $$('[data-value]', root).forEach(function (btn) {
      btn.addEventListener('click', function () {
        var group = btn.closest('[data-option-index]');
        $$('[data-value]', group).forEach(function (b) { b.setAttribute('aria-pressed', 'false'); });
        btn.setAttribute('aria-pressed', 'true');
        updateUI();
      });
    });

    function collectProperties() {
      var props = {};
      var mono = $('[data-monogram-toggle]', root);
      var initials = $('[data-monogram-input]', root);
      if (mono && mono.checked && initials && initials.value.trim()) {
        props['Engraved initials'] = initials.value.trim().toUpperCase();
      }
      return props;
    }

    var monoToggle = $('[data-monogram-toggle]', root);
    if (monoToggle) {
      monoToggle.addEventListener('change', function () {
        var wrap = $('[data-monogram-field]', root);
        if (wrap) wrap.classList.toggle('hidden', !monoToggle.checked);
      });
    }
    var monoInput = $('[data-monogram-input]', root);
    if (monoInput) {
      monoInput.addEventListener('input', function () {
        monoInput.value = monoInput.value.toUpperCase().replace(/[^A-Z]/g, '').slice(0, 3);
      });
    }

    function addCurrent(thenCheckout) {
      var idInput = $('[data-variant-id]', root);
      if (!idInput || !idInput.value) return;
      var atc = $('[data-atc]', root);
      if (atc) atc.classList.add('is-loading');
      var items = [{ id: parseInt(idInput.value, 10), quantity: 1 }];
      var props = collectProperties();
      if (Object.keys(props).length) items[0].properties = props;
      var engraveInput = $('[data-engraving-variant]', root);
      var monoT = $('[data-monogram-toggle]', root);
      var monoI = $('[data-monogram-input]', root);
      if (engraveInput && monoT && monoT.checked && monoI && monoI.value.trim()) {
        items.push({
          id: parseInt(engraveInput.value, 10),
          quantity: 1,
          properties: { 'Initials': monoI.value.trim().toUpperCase(), 'For': productData.title }
        });
      }
      cart.addItems(items)
        .then(function () {
          if (thenCheckout) { window.location.href = window.routes.cart_url + '/checkout'; return; }
          return cart.refresh().then(function () {
            cart.open();
            if (atc) {
              var label = $('[data-atc-label]', atc);
              var prev = label.textContent;
              label.textContent = atc.getAttribute('data-added-text');
              setTimeout(function () { updateUI(); }, 2000);
            }
          });
        })
        .catch(function (e) {
          toast((e && e.description) || 'Could not add to basket');
        })
        .then(function () { if (atc) atc.classList.remove('is-loading'); });
    }

    var atcBtn = $('[data-atc]', root);
    if (atcBtn) atcBtn.addEventListener('click', function (e) { e.preventDefault(); addCurrent(false); });
    var stickyAtc = $('[data-sticky-atc]', root);
    if (stickyAtc) stickyAtc.addEventListener('click', function (e) { e.preventDefault(); addCurrent(false); });
    var buyNowBtn = $('[data-buy-now]', root);
    if (buyNowBtn) buyNowBtn.addEventListener('click', function (e) { e.preventDefault(); addCurrent(true); });

    updateUI();
  }

  /* ---------- product gallery ---------- */
  var galleryState = { active: 0, images: [], filtered: null };

  /* WYDAJNOŚĆ — 21.10.2026 (szybki mobile, zdjęcia)
     1. Miniatury nie mają już `src` w HTML (tylko data-src / data-srcset).
        Wcześniej przeglądarka pobierała WSZYSTKIE ~50 miniatur (300 px, ~500 kB)
        zanim skrypt zdążył ukryć miniatury innych kolorów — i to w tym samym
        momencie co główne zdjęcie, które przez to ładowało się wolno.
        Teraz hydrateThumbs() podstawia źródła tylko widocznym miniaturom
        (aktywny kolor), w rozmiarze dopasowanym do kafelka (120–300 px).
     2. Po załadowaniu głównego zdjęcia w tle (idle) pobierają się sąsiednie
        zdjęcia (następne i poprzednie) w tym samym rozmiarze, który wybiera
        przeglądarka — przesunięcie palcem / strzałka pokazuje zdjęcie od razu.
     3. Podgląd pełnoekranowy (lightbox) na telefonie: najpierw plik w rozmiarze
        ekranu (zwykle ten sam, który jest już w pamięci przeglądarki), duży plik
        do powiększenia 2,2x dociąga się dopiero przy faktycznym powiększeniu. */
  var GALLERY_WIDTHS = [640, 900, 1080, 1400, 2000, 2800];

  function hydrateThumbs() {
    $$('[data-gallery-thumb] img[data-src]').forEach(function (im) {
      var b = im.closest('[data-gallery-thumb]');
      if (b && b.classList.contains('hidden')) return;
      if (im.getAttribute('data-srcset')) { im.srcset = im.getAttribute('data-srcset'); im.removeAttribute('data-srcset'); }
      im.src = im.getAttribute('data-src');
      im.removeAttribute('data-src');
    });
  }
  window.galleryHydrateThumbs = hydrateThumbs;

  /* width the phone actually needs for a full-width gallery photo — mirrors the
     `sizes` of the main image: 75vw on >= 2.5x screens, 100vw below */
  function phoneWidth() {
    var dpr = window.devicePixelRatio || 1;
    var f = (window.matchMedia && window.matchMedia('(min-resolution: 2.5dppx)').matches) ? 0.75 : 1;
    var need = window.innerWidth * f * dpr;
    for (var i = 0; i < GALLERY_WIDTHS.length; i++) { if (GALLERY_WIDTHS[i] >= need) return GALLERY_WIDTHS[i]; }
    return GALLERY_WIDTHS[GALLERY_WIDTHS.length - 1];
  }
  function srcsetPick(srcset, w) {
    var hit = null;
    String(srcset || '').split(',').forEach(function (part) {
      var bits = part.trim().split(/\s+/);
      if (bits.length === 2 && parseInt(bits[1], 10) === w) hit = bits[0];
    });
    return hit;
  }
  window.harrowPhoneWidth = phoneWidth;

  var galleryWarm = {};
  function galleryPreload(i) {
    var data = galleryState.images[i];
    if (!data || galleryWarm[i]) return;
    var main = $('[data-gallery-main] img');
    if (!main) return;
    galleryWarm[i] = true;
    var im = new Image();
    im.decoding = 'async';
    im.sizes = main.getAttribute('sizes') || '100vw';
    if (data.srcset) im.srcset = data.srcset;
    im.src = data.src;
  }
  function galleryList() {
    return galleryState.filtered && galleryState.filtered.length
      ? galleryState.filtered
      : galleryState.images.map(function (_, i) { return i; });
  }
  function warmNeighbours() {
    var list = galleryList();
    if (list.length < 2) return;
    var pos = list.indexOf(galleryState.active);
    if (pos === -1) pos = 0;
    [1, -1].forEach(function (d) {
      galleryPreload(list[((pos + d) % list.length + list.length) % list.length]);
    });
  }
  var warmTimer = null;
  function scheduleNeighbours() {
    var main = $('[data-gallery-main] img');
    if (!main) return;
    function run() {
      if (warmTimer) return;
      warmTimer = (window.requestIdleCallback || function (f) { return setTimeout(f, 300); })(function () {
        warmTimer = null;
        warmNeighbours();
      }, { timeout: 2000 });
    }
    if (main.complete && main.naturalWidth) run();
    else main.addEventListener('load', run, { once: true });
  }

  /* Colour-aware gallery (02.09.2026 rewrite).
     Photographs name their colourway in the alt text — in English, Polish,
     German or Italian — while option values may be in another language
     ("Black" vs "Czarny", "Burgundy" vs "Burgund"). Both sides are reduced to
     a canonical colour key before matching, so selecting a colour shows only
     that colour's shots: one colour per dot. The variant's own photo (if it
     has one) always comes first. If nothing matches, the full set is shown. */
  var COLOUR_SYNONYMS = {
    black: ['black', 'czarny', 'czarne', 'schwarz', 'nero'],
    graphite: ['graphite', 'grafitowy', 'grafit', 'graphit', 'grafite', 'charcoal', 'anthracite', 'antracyt'],
    slate: ['slate', 'łupkowy', 'schiefer', 'ardesia'],
    brown: ['brown', 'brązowy', 'braun', 'marrone'],
    tan: ['tan', 'saddle tan', 'cognac', 'koniakowy', 'cammello', 'saddle'],
    navy: ['navy', 'granatowy', 'marine', 'blau', 'blu'],
    burgundy: ['burgundy', 'burgund', 'bordowy', 'bordeaux', 'bordo'],
    olive: ['olive', 'oliwkowy', 'oliv', 'oliva'],
    espresso: ['espresso', 'chocolate', 'czekoladowy', 'schokolade', 'cioccolato'],
    terracotta: ['terracotta', 'terakota', 'terrakotta'],
    taupe: ['taupe'],
    ivory: ['ivory', 'kość słoniowa', 'kremowy', 'cream', 'elfenbein', 'avorio'],
    grey: ['grey', 'gray', 'szary', 'grau', 'grigio'],
    white: ['white', 'biały', 'weiß', 'bianco'],
    red: ['red', 'czerwony', 'rot', 'rosso'],
    green: ['green', 'zielony', 'grün', 'verde']
  };
  function escapeRe(s) { return s.replace(/[.*+?^${}()|[\]\\]/g, '\\$&'); }
  /* WYDAJNOŚĆ — 23.10.2026 (szybsze kliknięcia, INP)
     hasWord() kompilował od nowa ~75 wyrażeń regularnych z \p{L} przy każdym
     wywołaniu. Na karcie produktu kosztowało to ~170 ms przy wejściu (opisy
     wszystkich zdjęć) i ~45 ms przy każdym kliknięciu koloru — na szybkim
     komputerze; telefon jest 3–4x wolniejszy, a w tym czasie strona nie
     reaguje na dotyk. Teraz:
       1. szybki test indexOf odrzuca słowa, których w tekście w ogóle nie ma
          (całe słowo zawsze jest też podciągiem, więc wynik jest identyczny),
       2. skompilowane wyrażenie dla danego słowa powstaje raz i jest pamiętane,
       3. colourKeys() liczy wynik dla danego tekstu tylko raz.
     Dopasowanie (całe słowo, polskie/niemieckie/włoskie litery) bez zmian. */
  var wordRe = {};
  function hasWord(text, term) {
    if (text.indexOf(term) === -1) return false;
    var re = wordRe[term];
    if (re === undefined) {
      /* whole-word match that copes with accented letters; null = browser
         without Unicode property escapes → plain substring test (as before) */
      try {
        re = new RegExp('(^|[^\\p{L}])' + escapeRe(term) + '(?=[^\\p{L}]|$)', 'iu');
      } catch (e) {
        re = null;
      }
      wordRe[term] = re;
    }
    return re ? re.test(text) : true;
  }
  var colourMemo = {};
  function colourKeys(text) {
    var t = String(text || '').trim().toLowerCase();
    if (!t) return [];
    if (!Object.prototype.hasOwnProperty.call(colourMemo, t)) {
      colourMemo[t] = Object.keys(COLOUR_SYNONYMS).filter(function (key) {
        return COLOUR_SYNONYMS[key].some(function (w) { return hasWord(t, w); });
      });
    }
    return colourMemo[t].slice();
  }
  function galleryApplyColour(colour, variantPos) {
    var imgs = galleryState.images;
    if (!imgs.length) return;
    var all = imgs.map(function (_, i) { return i; });
    var idx = all;
    var vi = variantPos > 0 ? variantPos - 1 : -1;
    if (vi >= imgs.length) vi = -1;
    var c = String(colour || '').trim().toLowerCase();
    if (c) {
      var keys = colourKeys(c);
      var key = keys.length ? keys[0] : null;
      var matched = [];
      imgs.forEach(function (im, i) {
        if (!im.keys) im.keys = colourKeys(im.alt);
        var alt = String(im.alt || '').toLowerCase();
        var hit = key ? im.keys.indexOf(key) !== -1 : false;
        /* unknown colour names: plain substring in either direction */
        if (!hit && !key && alt) hit = alt.indexOf(c) !== -1 || c.indexOf(alt) !== -1;
        if (hit) matched.push(i);
      });
      if (vi >= 0) {
        matched = [vi].concat(matched.filter(function (i) { return i !== vi; }));
      }
      if (matched.length) idx = matched;
    } else if (vi >= 0) {
      idx = [vi].concat(all.filter(function (i) { return i !== vi; }));
    }
    galleryState.filtered = idx;
    $$('[data-gallery-thumb]').forEach(function (t, j) {
      t.classList.toggle('hidden', idx.indexOf(j) === -1);
    });
    $$('[data-lightbox-thumb]').forEach(function (t, j) {
      t.classList.toggle('hidden', idx.indexOf(j) === -1);
    });
    hydrateThumbs();
    gallerySet(idx[0]);
  }
  window.galleryApplyColour = galleryApplyColour;

  function galleryStep(delta) {
    var list = galleryState.filtered && galleryState.filtered.length
      ? galleryState.filtered
      : galleryState.images.map(function (_, i) { return i; });
    var pos = list.indexOf(galleryState.active);
    if (pos === -1) pos = 0;
    var next = ((pos + delta) % list.length + list.length) % list.length;
    gallerySet(list[next]);
  }

  function gallerySet(i) {
    var g = $('[data-gallery]');
    if (!g) return;
    var imgs = galleryState.images;
    if (!imgs.length) return;
    galleryState.active = ((i % imgs.length) + imgs.length) % imgs.length;
    var main = $('[data-gallery-main] img', g);
    var data = imgs[galleryState.active];
    if (main && data) {
      /* 23.10.2026 (INP): the same photo is not re-assigned — a size click
         keeps the colour's photo, and re-setting src/srcset made the browser
         re-select and re-paint the image for nothing */
      if (main.getAttribute('src') !== data.src || (main.getAttribute('srcset') || '') !== (data.srcset || '')) {
        main.src = data.src;
        main.srcset = data.srcset || '';
      }
      if (main.alt !== (data.alt || '')) main.alt = data.alt || '';
      scheduleNeighbours();
    }
    $$('[data-gallery-thumb]', g).forEach(function (t, j) {
      t.setAttribute('aria-current', j === galleryState.active ? 'true' : 'false');
    });
    var counter = $('[data-lightbox-counter]');
    var total = galleryState.filtered && galleryState.filtered.length ? galleryState.filtered.length : imgs.length;
    var pos = galleryState.filtered && galleryState.filtered.length ? galleryState.filtered.indexOf(galleryState.active) + 1 : galleryState.active + 1;
    if (counter) counter.textContent = pos + '/' + total;
    var lbImg = $('[data-lightbox-img]');
    /* 23.10.2026 (INP): the full-screen viewer image is only swapped while the
       viewer is open — lightboxOpen() calls gallerySet() right after opening, so
       it always shows the current photo. Before, every colour/size click reset
       the hidden viewer too, and writing its scroll position forced the browser
       to recalculate the whole page layout inside the click. */
    var lbBox = $('#GalleryLightbox');
    if (lbImg && data && (!lbBox || lbBox.dataset.open === 'true')) {
      /* a new image always starts un-zoomed (and scrolled back to the top-left) */
      var lbFrame = lbImg.closest('.lightbox__frame');
      if (lbFrame) lbFrame.classList.remove('zoomed', 'zoomed--pan');
      lbImg._lbz = null;
      lbImg.style.transform = ''; lbImg.style.transformOrigin = ''; lbImg.style.transition = ''; lbImg.style.width = ''; lbImg.style.height = '';
      var lbStage = lbImg.closest('.lightbox__stage');
      if (lbStage) { lbStage.scrollTop = 0; lbStage.scrollLeft = 0; }
      /* phones (21.10.2026): the viewer opens on the screen-sized file — usually
         the one the main photo already loaded, so it appears at once; the large
         file for the 2.2x zoom is requested only when the customer zooms
         (zApply swaps in data-zoom-srcset). Desktop keeps the 4000px file. */
      if (window.innerWidth < 768 && data.srcset) {
        lbImg.removeAttribute('srcset'); lbImg.removeAttribute('sizes');
        lbImg.setAttribute('data-zoom-srcset', data.srcset);
        lbImg.src = srcsetPick(data.srcset, phoneWidth()) || data.src;
      } else {
        lbImg.removeAttribute('data-zoom-srcset');
        lbImg.removeAttribute('srcset'); lbImg.removeAttribute('sizes'); lbImg.src = data.zoom || data.src;
      }
      lbImg.alt = data.alt || '';
    }
    $$('[data-lightbox-thumb]').forEach(function (t, j) {
      t.setAttribute('aria-current', j === galleryState.active ? 'true' : 'false');
    });
  }

  function initGallery() {
    var g = $('[data-gallery]');
    if (!g) return;
    galleryState.images = JSON.parse($('#GalleryJson').textContent);
    var main = $('[data-gallery-main]', g);
    var mainImg = main ? $('img', main) : null;

    if (main && mainImg) {
      main.addEventListener('mousemove', function (e) {
        var r = main.getBoundingClientRect();
        var x = ((e.clientX - r.left) / r.width) * 100;
        var y = ((e.clientY - r.top) / r.height) * 100;
        mainImg.style.transformOrigin = x + '% ' + y + '%';
      });
      /* touch swipe: left/right browses images (within the active colour filter) */
      var touchX = 0, touchY = 0, touchLive = false;
      window.__lastGallerySwipe = 0;
      main.addEventListener('touchstart', function (e) {
        if (e.touches.length !== 1) { touchLive = false; return; }
        touchX = e.touches[0].clientX; touchY = e.touches[0].clientY; touchLive = true;
      }, { passive: true });
      main.addEventListener('touchend', function (e) {
        if (!touchLive) return;
        touchLive = false;
        var dx = e.changedTouches[0].clientX - touchX;
        var dy = e.changedTouches[0].clientY - touchY;
        if (Math.abs(dx) > 45 && Math.abs(dx) > Math.abs(dy) * 1.5) {
          window.__lastGallerySwipe = Date.now();
          galleryStep(dx < 0 ? 1 : -1);
        }
      }, { passive: true });
      main.addEventListener('click', function () {
        if (Date.now() - window.__lastGallerySwipe < 400) return;
        lightboxOpen();
      });
      main.addEventListener('keydown', function (e) {
        if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); lightboxOpen(); }
      });
    }
    $$('[data-gallery-thumb]', g).forEach(function (t, i) {
      /* the photo starts downloading on finger-down, ~100 ms before the click */
      t.addEventListener('pointerdown', function () { galleryPreload(i); }, { passive: true });
      t.addEventListener('click', function () { gallerySet(i); });
    });
    $$('[data-gallery-prev]', g).forEach(function (b) {
      b.addEventListener('click', function (e) { e.stopPropagation(); galleryStep(-1); });
    });
    $$('[data-gallery-next]', g).forEach(function (b) {
      b.addEventListener('click', function (e) { e.stopPropagation(); galleryStep(1); });
    });

    /* lightbox */
    var lb = $('#GalleryLightbox');
    function lightboxOpen() {
      if (!lb) return;
      lb.dataset.open = 'true';
      document.body.classList.add('overflow-locked');
      gallerySet(galleryState.active);
    }
    function lightboxClose() {
      if (!lb) return;
      lb.dataset.open = 'false';
      document.body.classList.remove('overflow-locked');
      var frame = $('.lightbox__frame', lb);
      var fimg = $('[data-lightbox-img]', lb);
      if (frame) frame.classList.remove('zoomed', 'zoomed--pan');
      if (fimg) { fimg._lbz = null; fimg.style.transform = ''; fimg.style.transformOrigin = ''; fimg.style.transition = ''; fimg.style.width = ''; fimg.style.height = ''; }
    }
    if (lb) {
      $$('[data-lightbox-close]', lb).forEach(function (b) { b.addEventListener('click', lightboxClose); });
      $$('[data-lightbox-prev]', lb).forEach(function (b) { b.addEventListener('click', function () { galleryStep(-1); }); });
      $$('[data-lightbox-next]', lb).forEach(function (b) { b.addEventListener('click', function () { galleryStep(1); }); });
      $$('[data-lightbox-thumb]', lb).forEach(function (t, i) { t.addEventListener('click', function () { gallerySet(i); }); });
      var frame = $('.lightbox__frame', lb);
      var img = $('[data-lightbox-img]', lb);
      if (frame && img) {
        var stage = frame.closest('.lightbox__stage') || frame.parentNode;
        var ZOOM = 2.2, MAXZ = 4;
        var lastTouch = 0;

        /* ---- touch: tap to zoom, one finger pans, two fingers pinch (21.10.2026) ----
           Everything is one transform (translate + scale, origin at the image centre),
           driven by touch events; touch-action: none on the stage keeps the browser
           from fighting us (no page scroll / viewport zoom while the viewer is open). */
        function zState() { return img._lbz || (img._lbz = { s: 1, x: 0, y: 0 }); }
        function zCenter() {
          var r = img.getBoundingClientRect(), z = zState();
          return { x: r.left + r.width / 2 - z.x, y: r.top + r.height / 2 - z.y };
        }
        function zClamp() {
          var z = zState(), fr = stage.getBoundingClientRect();
          var w = img.offsetWidth * z.s, h = img.offsetHeight * z.s;
          var mx = Math.max(0, (w - fr.width) / 2), my = Math.max(0, (h - fr.height) / 2);
          z.x = Math.min(mx, Math.max(-mx, z.x));
          z.y = Math.min(my, Math.max(-my, z.y));
        }
        function zApply(animate) {
          var z = zState();
          /* first real zoom on a phone: now fetch the sharp file (the screen-sized
             one stays on screen until it has arrived, so nothing flickers) */
          if (z.s > 1 && img.getAttribute('data-zoom-srcset')) {
            img.sizes = '220vw';
            img.srcset = img.getAttribute('data-zoom-srcset');
            img.removeAttribute('data-zoom-srcset');
          }
          img.style.transition = animate ? '' : 'none';
          img.style.transformOrigin = '50% 50%';
          img.style.transform = (z.s === 1 && !z.x && !z.y) ? '' : 'translate(' + z.x + 'px, ' + z.y + 'px) scale(' + z.s + ')';
          frame.classList.toggle('zoomed', z.s > 1);
        }
        function zToggleAt(px, py) {
          var z = zState(), c = zCenter();
          if (z.s > 1 || !img.offsetWidth) { z.s = 1; z.x = 0; z.y = 0; }
          else { z.s = ZOOM; z.x = (px - c.x) * (1 - ZOOM); z.y = (py - c.y) * (1 - ZOOM); zClamp(); }
          zApply(true);
        }
        var g = null;
        function tpt(t) { return { x: t.clientX, y: t.clientY }; }
        function mid(a, b) { return { x: (a.x + b.x) / 2, y: (a.y + b.y) / 2 }; }
        function dist(a, b) { return Math.sqrt((a.x - b.x) * (a.x - b.x) + (a.y - b.y) * (a.y - b.y)); }
        stage.addEventListener('touchstart', function (e) {
          if (e.target.closest('button')) { g = null; return; }
          var z = zState(), ts = e.touches;
          if (ts.length === 1) {
            var p = tpt(ts[0]);
            g = { type: 'pan', p0: p, s0: z.s, t0: { x: z.x, y: z.y }, c: zCenter(), moved: false, t: Date.now() };
          } else if (ts.length >= 2) {
            var a = tpt(ts[0]), b = tpt(ts[1]);
            g = { type: 'pinch', m0: mid(a, b), d0: dist(a, b), s0: z.s, t0: { x: z.x, y: z.y }, c: zCenter(), moved: true };
          }
        }, { passive: true });
        stage.addEventListener('touchmove', function (e) {
          if (!g) return;
          var z = zState(), ts = e.touches;
          if (g.type === 'pinch' && ts.length >= 2) {
            var a = tpt(ts[0]), b = tpt(ts[1]), m = mid(a, b);
            var s = Math.min(MAXZ, Math.max(1, g.s0 * dist(a, b) / (g.d0 || 1)));
            z.s = s;
            z.x = m.x - g.c.x - s * (g.m0.x - g.c.x - g.t0.x) / g.s0;
            z.y = m.y - g.c.y - s * (g.m0.y - g.c.y - g.t0.y) / g.s0;
            zClamp(); zApply(false);
            if (e.cancelable) e.preventDefault();
          } else if (g.type === 'pan' && ts.length === 1) {
            var p = tpt(ts[0]);
            if (Math.abs(p.x - g.p0.x) > 6 || Math.abs(p.y - g.p0.y) > 6) g.moved = true;
            if (z.s > 1) {
              z.x = g.t0.x + (p.x - g.p0.x); z.y = g.t0.y + (p.y - g.p0.y);
              zClamp(); zApply(false);
              if (e.cancelable) e.preventDefault();
            }
          }
        }, { passive: false });
        stage.addEventListener('touchend', function (e) {
          lastTouch = Date.now();
          if (!g) return;
          var z = zState();
          if (e.touches.length === 0) {
            var ct = e.changedTouches && e.changedTouches[0] ? tpt(e.changedTouches[0]) : g.p0;
            if (g.type === 'pan' && !g.moved && Date.now() - g.t < 400) {
              zToggleAt(g.p0.x, g.p0.y);                        /* tap: zoom in / out at the finger */
            } else if (g.type === 'pan' && g.moved && z.s === 1) {
              var dx = ct.x - g.p0.x, dy = ct.y - g.p0.y;        /* swipe: previous / next photo */
              if (Math.abs(dx) > 45 && Math.abs(dx) > Math.abs(dy) * 1.5) galleryStep(dx < 0 ? 1 : -1);
            } else if (z.s < 1.05) {
              z.s = 1; z.x = 0; z.y = 0; zApply(true);
            }
            g = null;
          } else if (e.touches.length === 1) {
            /* one finger lifted after a pinch: carry on panning with the other */
            var p = tpt(e.touches[0]);
            g = { type: 'pan', p0: p, s0: z.s, t0: { x: z.x, y: z.y }, c: zCenter(), moved: true, t: 0 };
          }
        });
        stage.addEventListener('touchcancel', function () { g = null; });

        /* ---- mouse: click toggles 2.2x, the cursor position pans (unchanged) ---- */
        frame.addEventListener('click', function (e) {
          if (e.target.closest('button')) return;
          if (Date.now() - lastTouch < 700) return;            /* already handled as a tap */
          img._lbz = null; img.style.transition = '';
          var zoomed = frame.classList.toggle('zoomed');
          img.style.transform = zoomed ? 'scale(' + ZOOM + ')' : '';
          if (!zoomed) img.style.transformOrigin = '';
        });
        frame.addEventListener('mousemove', function (e) {
          if (!frame.classList.contains('zoomed') || img._lbz) return;
          var r = frame.getBoundingClientRect();
          img.style.transformOrigin = (((e.clientX - r.left) / r.width) * 100) + '% ' + (((e.clientY - r.top) / r.height) * 100) + '%';
        });
      }
      document.addEventListener('keydown', function (e) {
        if (lb.dataset.open !== 'true') return;
        if (e.key === 'Escape') lightboxClose();
        if (e.key === 'ArrowRight') galleryStep(1);
        if (e.key === 'ArrowLeft') galleryStep(-1);
      });
    }
  }

  /* ---------- modals (size guide) ---------- */
  function initModals() {
    $$('[data-modal-open]').forEach(function (b) {
      b.addEventListener('click', function () {
        var m = $('#' + b.getAttribute('data-modal-open'));
        if (m) { m.dataset.open = 'true'; document.body.classList.add('overflow-locked'); }
      });
    });
    $$('.modal').forEach(function (m) {
      $$('[data-modal-close]', m).forEach(function (b) {
        b.addEventListener('click', function () { m.dataset.open = 'false'; document.body.classList.remove('overflow-locked'); });
      });
      var ov = $('.modal__overlay', m);
      if (ov) ov.addEventListener('click', function () { m.dataset.open = 'false'; document.body.classList.remove('overflow-locked'); });
    });
    document.addEventListener('keydown', function (e) {
      if (e.key !== 'Escape') return;
      $$('.modal[data-open="true"]').forEach(function (m) {
        m.dataset.open = 'false'; document.body.classList.remove('overflow-locked');
      });
    });
  }

  /* ---------- quick add (product cards) ---------- */
  function initQuickAdd() {
    $$('[data-quick-add]').forEach(function (b) {
      b.addEventListener('click', function (e) {
        e.preventDefault();
        cart.add(parseInt(b.getAttribute('data-quick-add'), 10), 1)
          .then(function () { return cart.refresh(); })
          .then(cart.open)
          .catch(function () { toast('Could not add to basket'); });
      });
    });
  }

  /* ---------- generic image lightbox (size guide etc.) ---------- */
  function initZoomables() {
    var triggers = $$('[data-zoomable]');
    if (!triggers.length) return;
    var overlay = document.createElement('div');
    overlay.className = 'img-lightbox';
    overlay.setAttribute('data-open', 'false');
    overlay.setAttribute('role', 'dialog');
    overlay.setAttribute('aria-modal', 'true');
    var closeLabel = triggers[0].getAttribute('data-close-label') || 'Close';
    overlay.innerHTML = '<button type="button" class="img-lightbox__close" aria-label="' + closeLabel + '">✕</button><img alt="">';
    document.body.appendChild(overlay);
    var img = overlay.querySelector('img');
    function close() {
      overlay.dataset.open = 'false';
      img.classList.remove('zoomed', 'zoomed--pan');
      img.style.width = ''; img.style.height = '';
      overlay.scrollTop = 0; overlay.scrollLeft = 0;
    }
    overlay.addEventListener('click', function (e) {
      if (e.target === img) {
        var fine = !!(window.matchMedia && window.matchMedia('(hover: hover) and (pointer: fine)').matches);
        if (fine) { img.classList.remove('zoomed--pan'); img.style.width = ''; img.style.height = ''; img.classList.toggle('zoomed'); return; }
        if (img.classList.contains('zoomed')) { close(); overlay.dataset.open = 'true'; return; }
        var r = img.getBoundingClientRect();
        var rx = r.width ? (e.clientX - r.left) / r.width : 0.5, ry = r.height ? (e.clientY - r.top) / r.height : 0.5;
        var newW = Math.round(r.width * 1.9), newH = Math.round(r.height * 1.9);
        img.style.width = newW + 'px'; img.style.height = newH + 'px';
        img.classList.add('zoomed', 'zoomed--pan');
        window.requestAnimationFrame(function () {
          overlay.scrollLeft = Math.max(0, rx * newW - overlay.clientWidth / 2);
          overlay.scrollTop = Math.max(0, ry * newH - overlay.clientHeight / 2);
        });
        return;
      }
      close();
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && overlay.dataset.open === 'true') close();
    });
    triggers.forEach(function (el) {
      el.addEventListener('click', function (e) {
        e.preventDefault();
        img.src = el.getAttribute('data-zoom-src') || el.currentSrc || el.src;
        img.alt = el.alt || '';
        overlay.dataset.open = 'true';
      });
    });
  }

  /* ---------- toast ---------- */
  var toastTimer;
  function toast(msg) {
    var t = $('#Toast');
    if (!t) return;
    t.textContent = msg;
    t.dataset.show = 'true';
    clearTimeout(toastTimer);
    toastTimer = setTimeout(function () { t.dataset.show = 'false'; }, 3000);
  }

  /* ---------- init ---------- */
  document.addEventListener('DOMContentLoaded', function () {
    initReveal(document);
    initMobileMenu();
    initCartTriggers();
    bindCartDrawer();
    initGallery();
    initProductForm();
    /* products without a colour option never call galleryApplyColour —
       their (visible) thumbnails get their sources here */
    hydrateThumbs();
    initModals();
    initZoomables();
    initQuickAdd();
  });

  document.addEventListener('shopify:section:load', function (e) {
    initReveal(e.target);
  });
})();

